import Bowser from 'bowser';

const browser = Bowser.getParser(navigator.userAgent);

export function isBrowserSupport() {
    return browser.satisfies({
        chrome: '>=111',
        edge: '>=125',
        firefox: '>=100',
        safari: '>=17',
        opera: '>=87',
        yandex: '>=23',
        'Yandex Browser Corp': '>=23',
    });
}

export function isOtherBrowser() {
    return !browser.satisfies({
        chrome: '>=0',
        edge: '>=0',
        firefox: '>=0',
        safari: '>=0',
        opera: '>=0',
        yandex: '>=0',
        'Yandex Browser Corp': '>=0',
    });
}
